import { MerchantAndStore } from './type';

export type CountBound = 'min' | 'max';
export type CountTier = { bound: CountBound; value: number };
export type CountBounds = { min?: number; max?: number };

const atMost = (...values: number[]): CountTier[] => values.map(value => ({ bound: 'max', value }));
const atLeast = (...values: number[]): CountTier[] => values.map(value => ({ bound: 'min', value }));

export const CLIENT_TIERS = [...atMost(0, 10, 50, 100), ...atLeast(10, 50, 100, 250, 500, 1000)];
export const PASSAGE_TIERS = [...atMost(0, 10, 50), ...atLeast(10, 50, 100, 250, 500, 1000)];
export const POINTS_TIERS = [...atMost(0, 100, 500), ...atLeast(100, 500, 1000, 5000, 10000)];
export const MARKETING_INACTIVITY_PERIODS = [7, 30, 90] as const;
export const NEVER_SENT = 'never';
export const URL_DATE_FORMAT = 'YYYY-MM-DD';

export type MarketingInactivity = (typeof MARKETING_INACTIVITY_PERIODS)[number] | typeof NEVER_SENT;

export type MerchantListFilters = {
  createdFrom?: string;
  createdTo?: string;
  minClients?: number;
  maxClients?: number;
  minPassages30d?: number;
  maxPassages30d?: number;
  minPointsEarned30d?: number;
  maxPointsEarned30d?: number;
  lastSms?: MarketingInactivity;
  lastPush?: MarketingInactivity;
  categoryId?: string;
};

export const MERCHANT_LIST_URL_KEYS = [
  'createdFrom',
  'createdTo',
  'minClients',
  'maxClients',
  'minPassages',
  'maxPassages',
  'minPoints',
  'maxPoints',
  'lastSms',
  'lastPush',
  'category',
] as const;

export type MerchantListUrlKey = (typeof MERCHANT_LIST_URL_KEYS)[number];

export type MerchantListPage = {
  data: MerchantAndStore[];
  metadata: { total: number; page: number; size: number };
};
